import { get } from 'services/api';

export const DNS_SETUP_URL = '/settings/dnsSetup.json';

/**
 * Fetch the DNS setup data
 */
export const getDnsSetup = () => get(DNS_SETUP_URL);
